export const iconFontAwesomeMoneyPercent = (
	<i className="fa-solid fa-percent"></i>
);
